// Users Action Types

export const GET_USERS_LIST_START = "GET_USERS_LIST_START";
export const GET_USERS_LIST_SUCCESS = "GET_USERS_LIST_SUCCESS";
export const GET_USERS_LIST_FAILURE = "GET_USERS_LIST_FAILURE";

export const GET_LABELS_LIST_START = "GET_LABELS_LIST_START";
export const GET_LABELS_LIST_SUCCESS = "GET_LABELS_LIST_SUCCESS";
export const GET_LABELS_LIST_FAILURE = "GET_LABELS_LIST_FAILURE";

export const GET_LABELS_SERVICE_LIST_START = "GET_LABELS_SERVICE_LIST_START";
export const GET_LABELS_SERVICE_LIST_SUCCESS = "GET_LABELS_SERVICE_LIST_SUCCESS";
export const GET_LABELS_SERVICE_LIST_FAILURE = "GET_SERVICE_LABELS_LIST_FAILURE";

export const GET_PARENT_LABELS_LIST_START = "GET_PARENT_LABELS_LIST_START";
export const GET_PARENT_LABELS_SUCCESS = "GET_PARENT_LABELS_LIST_SUCCESS";
export const GET_PARENT_LABELS_FAILURE = "GET_PARENT_LABELS_FAILURE";

export const GET_PARENT_LABEL_DATA_START = "GET_PARENT_LABEL_DATA_START";
export const GET_PARENT_LABEL_DATA_SUCCESS = "GET_PARENT_LABEL_DATA_SUCCESS";
export const GET_PARENT_LABEL_DATA_FAILURE = "GET_PARENT_LABEL_DATA_FAILURE";

export const ADD_NEW_LABEL_START = "ADD_NEW_LABEL_START";
export const ADD_NEW_LABEL_SERVICE_START = "ADD_NEW_LABEL_SERVICE_START";
export const ADD_NEW_PARENT_LABEL_START = "ADD_NEW_PARENT_LABEL_START";
export const ADD_NEW_LABEL_SUCCESS = "ADD_NEW_LABEL_SUCCESS";
export const ADD_NEW_LABEL_FAILURE = "ADD_NEW_LABEL_FAILURE";

export const LABELS_MESSAGE_HANDLER = "LABELS_MESSAGE_HANDLER";

export const GET_REFERENCES_LIST_START = "GET_REFERENCES_LIST_START";
export const GET_REFERENCES_LIST_SUCCESS = "GET_REFERENCES_LIST_SUCCESS";
export const GET_REFERENCES_LIST_FAILURE = "GET_REFERENCES_LIST_FAILURE";

export const ADD_NEW_REFERENCE_START = "ADD_NEW_REFERENCE_START";
export const ADD_NEW_REFERENCE_SUCCESS = "ADD_NEW_REFERENCE_SUCCESS";
export const ADD_NEW_REFERENCE_FAILURE = "ADD_NEW_REFERENCE_FAILURE";

export const REFERENCE_MESSAGE_HANDLER = "REFERENCE_MESSAGE_HANDLER";

export const GET_CP_MANAGERS_LIST_START = "GET_CP_MANAGERS_LIST_START";
export const GET_CP_MANAGERS_LIST_SUCCESS = "GET_CP_MANAGERS_LIST_SUCCESS";
export const GET_CP_MANAGERS_LIST_FAILURE = "GET_CP_MANAGERS_LIST_FAILURE";

export const ADD_CONTRACT_START = "ADD_CONTRACT_START";
export const ADD_CONTRACT_SUCCESS = "ADD_CONTRACT_SUCCESS";
export const ADD_CONTRACT_FAILURE = "ADD_CONTRACT_FAILURE";

export const GET_CP_SERVICES_LIST_START = "GET_CP_SERVICES_LIST_START";
export const GET_CP_SERVICES_LIST_SUCCESS = "GET_CP_SERVICES_LIST_SUCCESS";
export const GET_CP_SERVICES_LIST_FAILURE = "GET_CP_SERVICES_LIST_FAILURE";


export const GET_SERVICES_LIST_START = "GET_SERVICES_LIST_START";
export const GET_SERVICES_LIST_SUCCESS = "GET_SERVICES_LIST_SUCCESS";
export const GET_SERVICES_LIST_FAILURE = "GET_SERVICES_LIST_FAILURE";
export const SERVICE_MESSAGE_HANDLER = "SERVICE_MESSAGE_HANDLER";

export const GET_SERVICE_REPORT_START = "GET_SERVICE_REPORT_START";
export const GET_SERVICE_REPORT_SUCCESS = "GET_SERVICE_REPORT_SUCCESS";
export const GET_SERVICE_REPORT_FAILURE = "GET_SERVICE_REPORT_FAILURE";

export const GET_LABEL_SERVICE_REPORT_START = "GET_LABEL_SERVICE_REPORT_START";
export const GET_LABEL_SERVICE_REPORT_SUCCESS = "GET_LABEL_SERVICE_REPORT_SUCCESS";
export const GET_LABEL_SERVICE_REPORT_FAILURE = "GET_LABEL_SERVICE_REPORT_FAILURE";

export const GET_CONTENT_LIST_START = "GET_CONTENT_LIST_START";
export const GET_CONTENT_LIST_SUCCESS = "GET_CONTENT_LIST_SUCCESS";
export const GET_CONTENT_LIST_FAILURE = "GET_CONTENT_LIST_FAILURE";
export const GET_CONTENT_MESSAGE_HANDLER = "GET_CONTENT_MESSAGE_HANDLER";

export const GET_CONTENT_REPORT_START = "GET_CONTENT_REPORT_START";
export const GET_CONTENT_REPORT_SUCCESS = "GET_CONTENT_REPORT_SUCCESS";
export const GET_CONTENT_REPORT_FAILURE = "GET_CONTENT_REPORT_FAILURE";

export const SERVICE_REPORT_MESSAGE_HANDLER = "SERVICE_REPORT_MESSAGE_HANDLER";

export const GENERATE_REPORT_START = "GENERATE_REPORT_START";
export const GENERATE_REPORT_SUCCESS = "GENERATE_REPORT_SUCCESS";
export const GENERATE_REPORT_FAILURE = "GENERATE_REPORT_FAILURE";

// export const GET_USER_DATA_SUCCESS = "GET_USER_DATA_SUCCESS";
// export const GET_USER_DATA_FAILURE = "GET_USER_DATA_ERROR";

export const GET_USER_DATA_START = "GET_USER_DATA_START";
export const GET_USER_DATA_SUCCESS = "GET_USER_DATA_SUCCESS";
export const GET_USER_DATA_FAILURE = "GET_USER_DATA_ERROR";

export const MESSAGE_HANDLER = "MESSAGE_HANDLER";
export const CP_SERVICE_MESSAGE_HANDLER = "CP_SERVICE_MESSAGE_HANDLER";
export const CP_MESSAGE_HANDLER = "CP_MESSAGE_HANDLER";

export const ADD_NEW_USER_START = "ADD_NEW_USER_START";
export const ADD_NEW_USER_SUCCESS = "ADD_NEW_USER_SUCCESS";
export const ADD_NEW_USER_FAILURE = "ADD_NEW_USER_FAILURE";

export const ADD_NEW_CP_START = "ADD_NEW_CP_START";
export const ADD_NEW_CP_SUCCESS = "ADD_NEW_CP_SUCCESS";
export const ADD_NEW_CP_FAILURE = "ADD_NEW_CP_FAILURE";

export const GET_CP_START = "GET_CP_START";
export const GET_CP_SUCCESS= "GET_CP_SUCCESS";
export const GET_CP_FAILURE = "GET_CP_FAILURE";

export const UPDATE_USER_START = "UPDATE_USER_START";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAILURE = "UPDATE_USER_FAILURE";

export const DELETE_USER_START = "DELETE_USER_START";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_FAILURE = "DELETE_USER_FAILURE";

export const GET_EMPLOYEE_DATA_START = "GET_EMPLOYEE_DATA_START";
export const GET_EMPLOYEE_DATA_SUCCESS = "GET_EMPLOYEE_DATA_SUCCESS";
export const GET_EMPLOYEE_DATA_ERROR = "GET_EMPLOYEE_DATA_ERROR";

export const SIGNUP_START = "SIGNUP_START";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNUP_FAILURE = "SIGNUP_FAILURE";

export const LOGIN_START = "LOGIN_START";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";

export const LOGIN_ERROR_HANDLER_SUCCESS = "LOGIN_ERROR_HANDLER_SUCCESS";
export const LOGOUT = "LOGOUT";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";


export const DASHBOARD_START = "DASHBOARD_START";
export const DASHBOARD_SUCCESS = "DASHBOARD_SUCCESS";
export const DASHBOARD_FAILURE = "DASHBOARD_FAILURE";
export const DASHBOARD_ERROR_HANDLER_SUCCESS = "DASHBOARD_ERROR_HANDLER_SUCCESS";

export const FETCH_DRIVERS_START = "FETCH_DRIVERS_START";
export const FETCH_DRIVERS_SUCCESS = "FETCH_DRIVERS_SUCCESS";
export const FETCH_DRIVERS_FAILURE = "FETCH_DRIVERS_FAILURE";
export const DRIVER_ERROR_HANDLER_SUCCESS = "DRIVER_ERROR_HANDLER_SUCCESS";

export const FETCH_DRIVER_DATA_START = "FETCH_DRIVER_DATA_START";
export const FETCH_DRIVER_DATA_SUCCESS = "FETCH_DRIVER_DATA_SUCCESS";
export const FETCH_DRIVER_DATA_FAILURE = "FETCH_DRIVER_DATA_FAILURE";

export const UPDATE_DRIVER_DATA_START = "UPDATE_DRIVER_DATA_START";
export const UPDATE_DRIVER_DATA_SUCCESS = "UPDATE_DRIVER_DATA_SUCCESS";
export const UPDATE_DRIVER_DATA_FAILURE = "UPDATE_DRIVER_DATA_FAILURE";

export const FETCH_JOBS_START = "FETCH_JOBS_START";
export const FETCH_JOBS_SUCCESS = "FETCH_JOBS_SUCCESS";
export const FETCH_JOBS_FAILURE = "FETCH_JOBS_FAILURE";
export const JOB_ERROR_HANDLER_SUCCESS = "JOB_ERROR_HANDLER_SUCCESS";

export const FETCH_JOB_DATA_START = "FETCH_JOB_DATA_START";
export const FETCH_JOB_DATA_SUCCESS = "FETCH_JOB_DATA_SUCCESS";
export const FETCH_JOB_DATA_FAILURE = "FETCH_JOB_DATA_FAILURE";

export const UPDATE_JOB_DATA_START = "UPDATE_JOB_DATA_START";
export const UPDATE_JOB_DATA_SUCCESS = "UPDATE_JOB_DATA_SUCCESS";
export const UPDATE_JOB_DATA_FAILURE = "UPDATE_JOB_DATA_FAILURE";

export const FETCH_CUSTOMERS_START = "FETCH_CUSTOMERS_START";
export const FETCH_CUSTOMERS_SUCCESS = "FETCH_CUSTOMERS_SUCCESS";
export const FETCH_CUSTOMERS_FAILURE = "FETCH_CUSTOMERS_FAILURE";
export const CUSTOMER_ERROR_HANDLER_SUCCESS = "CUSTOMER_ERROR_HANDLER_SUCCESS";

export const FETCH_CUSTOMER_DATA_START = "FETCH_CUSTOMER_DATA_START";
export const FETCH_CUSTOMER_DATA_SUCCESS = "FETCH_CUSTOMER_DATA_SUCCESS";
export const FETCH_CUSTOMER_DATA_FAILURE = "FETCH_CUSTOMER_DATA_FAILURE";

export const UPDATE_CUSTOMER_DATA_START = "UPDATE_CUSTOMER_DATA_START";
export const UPDATE_CUSTOMER_DATA_SUCCESS = "UPDATE_CUSTOMER_DATA_SUCCESS";
export const UPDATE_CUSTOMER_DATA_FAILURE = "UPDATE_CUSTOMER_DATA_FAILURE";

export const FETCH_VEHICLES_START = "FETCH_VEHICLES_START";
export const FETCH_VEHICLES_SUCCESS = "FETCH_VEHICLES_SUCCESS";
export const FETCH_VEHICLES_FAILURE = "FETCH_VEHICLES_FAILURE";
export const VEHICLE_ERROR_HANDLER_SUCCESS = "VEHICLE_ERROR_HANDLER_SUCCESS";

export const FETCH_VEHICLE_DATA_START = "FETCH_VEHICLE_DATA_START";
export const FETCH_VEHICLE_DATA_SUCCESS = "FETCH_VEHICLE_DATA_SUCCESS";
export const FETCH_VEHICLE_DATA_FAILURE = "FETCH_VEHICLE_DATA_FAILURE";

export const UPDATE_VEHICLE_DATA_START = "UPDATE_VEHICLE_DATA_START";
export const UPDATE_VEHICLE_DATA_SUCCESS = "UPDATE_VEHICLE_DATA_SUCCESS";
export const UPDATE_VEHICLE_DATA_FAILURE = "UPDATE_VEHICLE_DATA_FAILURE";
